import { ApolloError, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { ORG_TIMEZONE } from "@/api/queries/orgTimeZone";

export function useOrgTimeZone(): {
  timeZone?: string | null;
  loading: boolean;
  error: ApolloError | undefined;
} {
  const { orgId } = useParams<{ orgId: string | undefined }>();
  const { data, loading, error } = useQuery(ORG_TIMEZONE, {
    variables: { id: orgId ?? "" },
    skip: !orgId,
  });

  if (data?.node?.__typename === "Organization") {
    return { timeZone: data?.node?.timeZone, loading, error };
  } else {
    return { loading, error };
  }
}
